import Swal from "sweetalert2";
import { getDateHour } from "../../../utils/DateHour";
import { clearEditProductMemory, clearListCatalogs, clearProductsMemory, processRequest, setCatalogProduct, setEditProduct, setError, setListCatalogs } from "./slice";
import apiConnection from "../../Connection";
import { calculateProductStatus, validateStockInputs } from "../../../utils/validatorStock";

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 2500,
    timerProgressBar: true,
    didOpen: (toast) => {
        // toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
});

// Funcion para obtener la fecha y hora desde servidor remoto
// const { fecha, hora, fuente } = await getDateHour();
export const clearListProducts = () => {
    return (dispatch, getState) => {
        dispatch(clearProductsMemory());
    }
}

export const clearEditProduct = () => {
    return (dispatch, getState) => {
        dispatch(clearEditProductMemory());
    }
}

export const clearListCatalogRegister = () => {
    return (dispatch, getState) => {
        dispatch(clearListCatalogs());
    }
}

export const loadCatalogs = () => {
    return async (dispatch, getState) => {
        dispatch(clearListCatalogs());
        dispatch(processRequest());
        await apiConnection.get(`/Products/getCatalogs`).then(function (response) {
            if (response.data.status == 200) {
                dispatch(
                    setListCatalogs({
                        msg: 'Catalogos disponibles',
                        listCategories: response.data.categories,
                        listSuppliers: response.data.suppliers,
                        listBrands: response.data.brands,
                    })
                );
            }
        }).catch(function (error) {
            console.log(error);
            dispatch(setError())
        });
    }
}


let statusProdX = 0;

export const loadProducts = (statusProd) => {
    return async (dispatch, getState) => {
        dispatch(clearProductsMemory());
        dispatch(processRequest());
        await apiConnection.get(`/Products/getProducts/${statusProd}`).then(function (response) {
            if (response.data.status == 200) {
                dispatch(
                    setCatalogProduct({
                        msg: 'Listado de Productos cargado',
                        catalog: response.data.data,
                    })
                );
            }
        }).catch(function (error) {
            console.log(error);
            dispatch(setError())
        });
    }
}

export const loadDetailProduct = (sku) => {
    return async (dispatch, getState) => {
        dispatch(clearEditProductMemory());
        dispatch(processRequest());
        await apiConnection.get(`/Products/getProductbyID/${sku}`).then(function (response) {
            if (response.data.status == 200) {
                dispatch(
                    setEditProduct({
                        msg: 'Producto encontrado',
                        detail: response.data.data,
                        history: response.data.history,
                    })
                );
            }
        }).catch(function (error) {
            console.log(error);
            dispatch(setError())
        });
    }
}





export const newProduct = (data, userName) => {
    return async (dispatch, getState) => {
        const { fecha, hora, fuente } = await getDateHour();

        // validateStockInputs(
        //     Number(data.currentStockProduct),
        //     Number(data.minStockProduct),
        //     Number(data.maxStockProduct)
        // );


        const productStatus = calculateProductStatus(
            Number(data.currentStockProduct),
            Number(data.minStockProduct),
            Number(data.maxStockProduct)
        );

        dispatch(processRequest());
        await apiConnection.post(`/Products/postProducts`, {
            // SKU: data.sku,
            TYPEID: data.typeID,
            DURATION: data.durationProduct ?? 0,
            TERMS: data.termsConditionsProduct ?? '',
            BARCODE: data.barcode,
            NAME_PRODUCT: data.nameProduct,
            DESCRIPTION_PRODUCT: data.descriptionProduct,
            PURCHASE_PRICE: data.costProduct,
            SALE_PRICE: data.priceProduct,
            MIN_STOCK: data.minStockProduct,
            MAX_STOCK: data.maxStockProduct,
            ACTIVE: productStatus,
            DATEREGISTER: fecha,
            USERREGISTER: userName,
            LASTUPDATE_AT: fecha,
            USERUPDATE: userName,
            IDCATEGORY: data.categoryID,
            IDSUPPLIER: data.supplierID,
            IDBRAND: data.brandID,
            CREATED_AT: fecha,
            UPDATED_AT: fecha,
            CURRENTSTOCK: data.currentStockProduct,
            LASTUPDATEHOUR: hora
        }).then(function (response) {
            if (response.data.status = 200) {
                Toast.fire({
                    icon: 'success',
                    title: 'Producto registrado...'
                })
                dispatch(loadProducts(statusProdX));
            }
        }).catch(function (error) {
            console.log(error)
            Toast.fire({
                icon: 'error',
                title: 'No se registro el producto... favor de intentar de Nuevo'
            })
            dispatch(loadProducts(statusProdX));
            return;
        });

    }
}

export const editProduct = (data, sku, id, userName, password) => {
    return async (dispatch, getState) => {
        const { fecha, hora, fuente } = await getDateHour();
        dispatch(processRequest());
        await apiConnection.put(`/Products/putProduct/${sku}/${id}`, {
            // SKU: data.sku,
            DURATION: data.durationProduct ?? 0,
            TERMS: data.termsConditionsProduct ?? '',
            BARCODE: data.barcode,
            NAME_PRODUCT: data.nameProduct,
            DESCRIPTION_PRODUCT: data.descriptionProduct,
            PURCHASE_PRICE: data.costProduct,
            SALE_PRICE: data.priceProduct,
            MIN_STOCK: data.minStockProduct,
            MAX_STOCK: data.maxStockProduct,
            ACTIVE: data.statusProduct,
            LASTUPDATE_AT: fecha,
            USERUPDATE: userName,
            IDCATEGORY: data.categoryID,
            IDSUPPLIER: data.supplierID,
            IDBRAND: data.brandID,
            UPDATED_AT: fecha,
            LASTUPDATEHOUR: hora,
            PASSWORD: password ? password : '',
            NEW_STOCK: data.newStock ? Number(data.newStock) : 0,
            ADD_STOCK: data.addStock ? Number(data.addStock) : 0
        }).then(function (response) {
            if (response.data.status = 200) {
                Toast.fire({
                    icon: 'success',
                    title: 'Producto actualizado...'
                })
                dispatch(loadDetailProduct(sku));
            }
        }).catch(function (error) {
            console.log(error)
            Toast.fire({
                icon: 'error',
                title: 'No se actualizo el producto... favor de intentar de Nuevo'
            });
            console.log(sku);
            
            dispatch(loadDetailProduct(sku));
        });

    }
}

export const deactivateProduct = (id) => {
    return async (dispatch, getState) => {
        dispatch(processRequest());
        await apiConnection.put(`/Products/putDeactivateProduct/${id}`).then(function (response) {
            // console.log(response.data);
            if (response.data.status == 200) {
                Toast.fire({
                    icon: 'success',
                    title: 'Producto desactivado...'
                })
                dispatch(loadProducts(statusProdX))
            }
            else {
                Toast.fire({
                    icon: 'success',
                    title: 'No fue posible desactivar el Producto, favor de intentar de nuevo...'
                })
                dispatch(loadProducts(statusProdX));
            }
        }).catch(function (error) {
            Toast.fire({
                icon: 'success',
                title: 'No fue posible desactivar el Producto, favor de intentar de nuevo...'
            })
            dispatch(loadProducts(statusProdX));
            // console.log(error);
            dispatch(setError());
        });
    }
}

export const activateProduct = (id) => {
    return async (dispatch, getState) => {
        dispatch(processRequest());
        await apiConnection.put(`/Products/putActivateProduct/${id}`).then(function (response) {
            // console.log(response.data);
            if (response.data.status == 200) {
                Toast.fire({
                    icon: 'success',
                    title: 'Producto Activado...'
                })
                dispatch(loadProducts(statusProdX))
            }
            else {
                Toast.fire({
                    icon: 'success',
                    title: 'No fue posible activar el Producto, favor de intentar de nuevo...'
                })
                dispatch(loadProducts(statusProdX));
            }
        }).catch(function (error) {
            Toast.fire({
                icon: 'success',
                title: 'No fue posible activar el Producto, favor de intentar de nuevo...'
            })
            dispatch(loadProducts(statusProdX));
            console.log(error);
            dispatch(setError());
        });
    }
}





